import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RailDocument } from 'shared/models/api/models';
import { DocumentFilterList } from 'components/menu/Labels';
import { IDocumentFilter, RelatedRulebookDocumentViewTraditional, RelatedRulebookDocumentViewCBTC } from 'components/ui/DocumentRules';

import { HighlightOffOutlined, KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { ReactComponent as RelatedDocumentsLinkIcon } from "assets/icons/related-documents.svg";
import './Viewer.css'
import { getUserExistingRulebookMode } from '../../../shared/store/applicationState';
import { RulebookModeEnum, RulebookNameToEnum } from '../../../shared/enums/rulebook-mode-enum';


interface RelatedDocumentsProps {
    relatedDocuments: Array<RailDocument>,
    document: RailDocument
}

export const RelatedDocuments = (props: RelatedDocumentsProps) => {
    const [showRelatedDocs, setShowRelateDocs] = useState(false);
    const [expandedFilters, setExpandedFilters] = useState([] as IDocumentFilter[]);
    const [activeFilter, setActiveFilter] = useState({} as IDocumentFilter | null);

    const navigate = useNavigate();

    const updateActiveFilter = (filter: IDocumentFilter | null) => {
        setActiveFilter(filter);

        if (filter === null && activeFilter) {
            setExpandedFilters(expandedFilters.filter(f => f !== activeFilter));
        } else {
            if (activeFilter !== null) {
                setExpandedFilters(expandedFilters.concat([activeFilter]));
            } else {
                setExpandedFilters(expandedFilters.filter(f => f !== filter));
            }
        }
    };

    const navigateToDocument = (doc: RailDocument) => {
        setShowRelateDocs(false);
        const mode = getUserExistingRulebookMode();
        navigate(`/pdf/view/${mode}/${doc.id}`);
    }

    let currentMode= getUserExistingRulebookMode();
    useEffect(() => {
      //  currentMode = getUserExistingRulebookMode();
        if (RulebookNameToEnum(currentMode) === RulebookModeEnum.Traditional) {
            setExpandedFilters(RelatedRulebookDocumentViewTraditional.filters);
        } else if (RulebookNameToEnum(currentMode) === RulebookModeEnum.CBTC) {
            setExpandedFilters(RelatedRulebookDocumentViewCBTC.filters);
        } else {
            console.log('Error: Failed to set ExpandedFilters');
        }        
    }, []);

    return (
        <div className={"related-documents" + (showRelatedDocs ? " expanded" : " collapsed")}>
            {(props.relatedDocuments.length > 0) && <>
                <div className="related-expand-button" onClick={() => setShowRelateDocs(!showRelatedDocs)}>
                    <div className="rail-button">
                        <RelatedDocumentsLinkIcon />
                    </div>
                    <div className="label">Related documents</div>
                    <div className="caret">{showRelatedDocs ? <KeyboardArrowDownOutlined /> : <KeyboardArrowUpOutlined />}</div>
                </div>
            </>}

            {showRelatedDocs &&
                <div className="related-documents-container">
                    <div className="heading">
                        <div className="close-button">
                            <HighlightOffOutlined onClick={() => setShowRelateDocs(false)} />
                        </div>
                        <div className="label">Related documents: {props.document.title} </div>
                    </div>
                    <div className="related-documents-items">
                        <DocumentFilterList
                            view={RulebookNameToEnum(currentMode!) === RulebookModeEnum.Traditional ? RelatedRulebookDocumentViewTraditional :
                                RulebookNameToEnum(currentMode!) === RulebookModeEnum.CBTC ? RelatedRulebookDocumentViewCBTC : null}
                            selectedDocuments={props.relatedDocuments}
                            expandedFilters={expandedFilters}
                            activeFilter={activeFilter}
                            setActiveFilter={updateActiveFilter}
                            onDocumentClick={navigateToDocument}
                            hideSubFilters={true} />
                    </div>
                </div>
            }
        </div>
    );
}
